import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import RoomPopup from './RoomPopup';

const RoomItem = ({
    auth,
    room: { _id, roomno, acstatus, maxcount, roomtype, date, description },
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

return (
    <Col>
        <Card border='warning'>
            <Card.Header>
                Room Number : {roomno}
            </Card.Header>
            <Card.Body>
                <table className='room-card-table'>
                    <tbody>
                        <tr>
                            <td>
                                <tr><td>Date</td><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                                <tr><td>Type</td><td>{roomtype}</td></tr>
                                <tr><td>AC</td><td>{acstatus===true ? ('Yes') : ('No')}</td></tr>
                                <tr><td>Max Count</td><td>{maxcount}</td></tr>
                                <tr><td>Description</td><td>{description}</td></tr>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
            <Card.Footer>
                <i className='fas fa-eye' onClick={togglePopup} style={{color: '#17a2b8', float: "right"}}></i>
                <i className='fas fa-pencil' style={{color: '#17a2b8'}}></i>
            </Card.Footer>
        </Card>
        {isOpen && <RoomPopup
                    content={
                        <>
                        <table style={{marginTop: '1rem'}} className='popup-application-item'>
                            <tbody>
                                <tr>
                                    <td>
                                        <tr><td>Room Id</td><td>{_id}</td></tr>
                                        <tr><td>Date</td><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                                        <tr><td>Room No.</td><td>{roomno}</td></tr>
                                        <tr><td>AC</td><td>{acstatus===true ? ('Yes') : ('No')}</td></tr>
                                    </td>
                                    <td>
                                        List of bookings in this room
                                        <table style={{marginTop: '1rem'}} className='popup-application-item'><tbody>

                                        </tbody></table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <i className="fas fa-trash" style={{color:'red'}} ></i>
                        </>
                    }
                    handleClose={togglePopup}
                />
                }
    </Col>
)};

RoomItem.propTypes = {
    room: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { })(
    RoomItem
);